import { TTreeDevice } from '@/features/devices/schemas/devices.schemas.ts';
import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
import { DeviceTreeTable } from './device-tree-table.tsx';
import { cn } from '@/utils/utils.ts';
import { useMemo } from 'react';

export function DeviceTreeTableCard({
  title,
  data,
  setData,
  deviceInfo,
  isLoading,
  className,
}: {
  title: string;
  data: TTreeDevice[];
  setData?: (devices: TTreeDevice[]) => void;
  deviceInfo?: {
    companyId: string;
    plantId: string;
    timezone: string;
  };
  isLoading?: boolean;
  className?: string;
}) {
  const sortedData = useMemo(() => sortDevicesRecursively(data, 'name'), [data]);

  return (
    <DashboardCard className={cn('min-h-[200px]', className)} isLoading={isLoading}>
      <div className="flex flex-col gap-4">
        <h3 className="font-semibold text-nowrap">{title}</h3>
        <DeviceTreeTable data={sortedData} setData={setData} deviceInfo={deviceInfo} />
      </div>
    </DashboardCard>
  );
}

function sortDevicesRecursively(
  devices: TTreeDevice[],
  sortKey: string,
  desc: boolean = false
): TTreeDevice[] {
  return devices
    .map(
      (item): TTreeDevice => ({
        ...item,
        subDevices: item.subDevices
          ? sortDevicesRecursively(item.subDevices, sortKey, desc)
          : undefined,
      })
    )
    .sort((a, b) => {
      return a.name.trim().localeCompare(b.name.trim(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    });
}
